import React from 'react'
import PropTypes from 'prop-types'
import { rhythm, scale } from '../utils/typography'
import Seo from '../components/Seo'
import Nav from '../components/Nav'
import Link from 'gatsby-link'

//This renders individual tags page e.g. http://localhost:8000/tags/tag-a/
const Tags = ({ pathContext, data }) => {
  const moment = require("moment")
  const now = moment(new Date());
  const { tag } = pathContext
  const { edges, totalCount } = data.allMarkdownRemark
  const tagHeader = `${totalCount} post${
    totalCount === 1 ? '' : 's'
    } tagged with "${tag}"`
  const config = require('../../content/meta/config')
  //const facebook = (((data || {}).site || {}).siteMetadata || {}).facebook
  const d = {
    title: 'All posts tagged ' + tag + ' at ' + config.shortSiteTitle,
    description: 'All posts tagged ' + tag + ' at ' + config.shortSiteTitle,
    image: config.siteImage,
    url: config.siteUrl + '/tags/' + tag,
    keywords: config.resumeKeywords,
    datePublished: "2018-07-01",
    dateUpdated: now.format("YYYY-MM-DD")
  }
  return (
    <div>
      <Seo data={d} pageType='taglist' />
      <Nav />
      {/* <h2 style={{
        marginTop: '0px'
      }}>{tagHeader}</h2> */}
      <p style={{
        marginBottom: '0px'
      }}>{tagHeader}</p>
      <ul style={{
        marginLeft: '0px'
      }}>
        {edges.map(({ node }) => {
          const { title } = node.frontmatter
          const tags = node.frontmatter.tags || []
          return (
            <div key={node.fields.slug} style={{
              // border: 'solid 1px red',
              // borderRadius: '50',
              // paddingLeft: rhythm(0.5),
              // margin: rhythm(0.5),
            }}>
              <h3
                style={{
                  marginBottom: rhythm(1 / 4),
                }}
              >
                <Link style={{ boxShadow: 'none' }} to={node.fields.slug}>
                  {title}
                </Link>
              </h3>
              {tags.map((tag, index) => {
                return (
                  <span
                    style={{
                      margin: '0px 12px 0px 0px',
                      paddingLeft: '4px',
                      //border: '1px solid rebeccapurple',
                    }}
                    key={index}
                    className="tag"
                  >
                    <Link
                      to={`/tags/${tag}`}
                      style={{
                        color: 'rebeccapurple',
                        textDecoration: 'none',
                      }}
                    >
                      {tag}
                    </Link>{' '}
                  </span>
                )
              })}
              <small>{node.frontmatter.date}</small>
              <p dangerouslySetInnerHTML={{ __html: node.excerpt }} />
            </div>
          )
        })}
      </ul>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between'
      }}>
        {/* <ul style={{
          marginLeft: '0px'
        }}> */}
        <h3>
          <Link style={{ boxShadow: 'none' }} to="/tags">All tags</Link>
        </h3>
        <h3>
          <Link style={{ boxShadow: 'none' }} to="/blog">All posts</Link>
        </h3>
        {/* </ul> */}
      </div>
    </div>
  )
}

Tags.propTypes = {
  pathContext: PropTypes.shape({
    tag: PropTypes.string.isRequired,
  }),
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      totalCount: PropTypes.number.isRequired,
      edges: PropTypes.arrayOf(
        PropTypes.shape({
          node: PropTypes.shape({
            frontmatter: PropTypes.shape({
              //path: PropTypes.string.isRequired,
              title: PropTypes.string.isRequired,
            }),
          }),
        }).isRequired
      ),
    }),
  }),
}

export default Tags

export const pageQuery = graphql`
  query TagPage($tag: String) {
    allMarkdownRemark(
      limit: 2000
      filter: { frontmatter: { tags: { in: [$tag] } } }
    ) {
      totalCount
      edges {
        node {
          excerpt
          frontmatter {
            title
            path
            tags
          }
          fields {
            slug
          }
        }
      }
    }
    site {
      siteMetadata {
        title
        facebook {
          appId
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/tags.js